import * as React from 'react'
import {IconButtonSeeker, TableSeekerContextProvider} from 'ui-seeker/core'
import { AppTooltip } from 'app/@components'
import SavedModal from "./Modal";
import {useSavedFiltersState} from "./@hooks";
import {useContextSelector} from "use-context-selector";
import {CommonFiltersSavedContext} from "../../context";
import {useEffect} from "react";

export default function SavedBtn({page}) {
    const {icon, handleClick, handleClose, open} = useSavedFiltersState()
    const updateState = useContextSelector(CommonFiltersSavedContext, ({updateState}) => updateState)

    useEffect(() => {
        updateState({page: page?.toUpperCase()})
    }, [])

    return <>
        <AppTooltip title="Save dashboard">
            <IconButtonSeeker
                icon="star"
                iconType="fontAwesome"
                iconWeight={icon}
                className="icon-filter-save-custom"
                onClick={handleClick}
            />
        </AppTooltip>
        <TableSeekerContextProvider>
            <SavedModal open={open} controller={handleClose} />
        </TableSeekerContextProvider>
    </>
}